import React from "react";
import LeadServiceType from "./LeadsServiceType";
import PatientCount from "../PatientCount";
import RevenueRate from "../RevenueRate";
import ConultantSummary from "./ConsultantSummary";
import Appointements from "./Appointments";

const MimoKonnect = () => {
  return (
    <div className="row p-2 gap-1">
      <div className="col-6 cards mb-2" style={{ minHeight: "222px" }}>
        <LeadServiceType />
      </div>
      <div className="col-5 cards mb-2" style={{ minHeight: "222px" }}>
        <PatientCount />
      </div>
      <div className="col-6 cards mb-2" style={{ minHeight: "222px" }}>
        <RevenueRate />
      </div>
      <div className="col-5 cards mb-2" style={{ minHeight: "222px" }}>
        <Appointements />
      </div>
      <div className="col-5 cards mb-2" style={{ minHeight: "222px",overflowY:"auto" }}>
        <ConultantSummary />
      </div>
    </div>
  );
};

export default MimoKonnect;
